<template>
  <div>
    <div ref="chart" style="width: 100%; height: 185px;"></div>
  </div>
</template>
<script>
import 'amcharts3';
import 'amcharts3/amcharts/pie';
import 'amcharts3/amcharts/themes/light';
import { isEmpty } from 'lodash';
import dateMixin from '@/mixins/date';
import moment from 'moment';

export default {
  name: 'shipment-by-state',
  mixins: [dateMixin],
  data() {
    return {
      cached_data: {},
    };
  },
  props: {
    range: {
      type: String,
      required: true,
    },
    startDate: {
      type: String,
      required: true,
    },
    endDate: {
      type: String,
      required: true,
    },
  },
  watch: {
    range(newRange) {
      if (this.cached_data.range !== newRange) {
        this.createChart();
        this.cached_data.range = newRange;
      }
    },
    startDate(date) {
      if (this.cached_data.start_date !== date) {
        this.createChart();
        this.cached_data.start_date = date;
      }
    },
    endDate(date) {
      if (this.cached_data.end_date !== date) {
        this.createChart();
        this.cached_data.end_date = date;
      }
    },
  },
  methods: {
    createChart: async function createChart() {
      setTimeout(async () => {
        const { chart: chartElem } = this.$refs;
        let dataProvider = [];

        this.setUpHeight();

        if (chartElem) chartElem.innerHTML = '<p class="no__data">Loading...</>';
        const resp = await this.loadData('shipment_md/shipments/SHIPMENT_BY_STATE');
        if (!isEmpty(resp)) {
          dataProvider = resp.detail_state.map(a => ({
            blok: a.state.replace(new RegExp('_', 'g'), ' '),
            value: a.count,
          }));
        }

        const title = this.getChartTitle();
        const startHumanize = this.formatDate(this.startDate);
        const endHumanize = this.formatDate(this.endDate);
        const subTitle = moment(this.startDate).isSame(this.endDate) ? startHumanize : `${startHumanize} - ${endHumanize}`;

        const chartConfig = {
          type: 'pie',
          fontFamily: "'Open Sans', sans-serif",
          startDuration: 0,
          theme: 'light',
          titles: [
            { text: title, size: 17 },
            { text: subTitle, bold: false },
          ],
          addClassNames: true,
          legend: {
            position: 'bottom',
            marginRight: 100,
            autoMargins: false,
          },
          innerRadius: '0%',
          defs: {
            filter: [{
              id: 'shadow',
              width: '200%',
              height: '200%',
              feOffset: {
                result: 'offOut',
                in: 'SourceAlpha',
                dx: 0,
                dy: 0,
              },
              feGaussianBlur: {
                result: 'blurOut',
                in: 'offOut',
                stdDeviation: 5,
              },
              feBlend: {
                in: 'SourceGraphic',
                in2: 'blurOut',
                mode: 'normal',
              },
            }],
          },
          valueField: 'value',
          titleField: 'blok',
          dataProvider,
        };

        if (isEmpty(resp.detail_state)) {
          if (chartElem) chartElem.innerHTML = '<p class="no__data">No Data Available</>';
        } else {
          window.AmCharts.makeChart(chartElem, chartConfig);
          this.removeChartTitleLink();
        }
      }, 5e2);
    },
    getChartTitle() {
      let title = this.range === 'custom' ? 'custom_date_range' : this.range;

      title = title
        .replace(new RegExp('_', 'g'), ' ')
        .replace(/\w\S*/g, txt => txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase());

      return title;
    },
    setUpHeight() {
      if (this.$refs.chart) {
        const wItem = this.$parent.$refs.item || { clientHeight: 0 };
        const newHeight = wItem.clientHeight - (39 + 5);
        this.$refs.chart.style.height = `${newHeight}px`;
      }
    },
    loadData(method) {
      return this.$store.dispatch(method, {
        start_date: this.startDate,
        end_date: this.endDate,
        state_filter_or: ['CREATED', 'FINISH_LOADING', 'ON_PROCESS', 'FINISH'],
      });
    },
    removeChartTitleLink() {
      const amChartTitle = document.querySelectorAll('a[title="JavaScript charts"]');
      for (let i = 0; i < amChartTitle.length; i++) {
        const chartTitle = amChartTitle[i];
        chartTitle.remove();
      }
    },
  },
  mounted() {
    this.createChart();
  },
};
</script>
<style lang="sass">
.amcharts-pie-slice
  transform: scale(1);
  transform-origin: 50% 50%;
  transition-duration: 0.3s;
  transition: all .3s ease-out;
  -webkit-transition: all .3s ease-out;
  -moz-transition: all .3s ease-out;
  -o-transition: all .3s ease-out;
  cursor: pointer;
  box-shadow: 0 0 30px 0 #000;

.amcharts-pie-slice:hover
  transform: scale(1.1);
  filter: url(#shadow);

.no__data
  margin-top: 0;
  margin: 8px;
  text-align: center;
</style>



// WEBPACK FOOTER //
// src/components/dashboard_widgets/ShipmentByState.vue